import { Button, styled } from '@mui/material';
import {
  kiwiGreen, sanguine, spaceCadet, ultraMarine,
} from '../../../../../utils/colors';

const DefaultAppBarButton = styled(Button)(({ theme }) => ({
  minWidth: 0,
  padding: '12px 16px',
  borderRadius: 24,
  backgroundColor: spaceCadet[300],
  color: spaceCadet[700],

  transition: theme.transitions.create(
    ['border-radius', 'background-color', 'color'],
    {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    },
  ),
  '&:hover': {
    borderRadius: 18,
    backgroundColor: spaceCadet[300],
  },

  '&.active': {
    backgroundColor: ultraMarine[500],
    color: 'white',
    borderRadius: 12,
    border: `2px solid ${ultraMarine[100]}`,
    padding: '10px 14px',
  },

  '& svg': {
    fontSize: 24,
  },

  '&.main': {
    padding: '12px 24px',
    backgroundColor: kiwiGreen[600],
    color: 'white',
    '&:hover': {
      borderRadius: 24,
    },

    '&.stop': {
      backgroundColor: sanguine[500],
      '&.inactiveSession': {
        backgroundColor: sanguine[300],
      },
    },
  },
  '&.more': {
    padding: '12px 6px',
  },
}));

export default DefaultAppBarButton;
